import { Link } from "react-router-dom";

function Navbar() {
  return (
    <nav style={{ padding: "10px", background: "#222" }}>
      <Link to="/" style={{ color: "white", marginRight: 15 }}>Dashboard</Link>
      <Link to="/books" style={{ color: "white", marginRight: 15 }}>Books</Link>
      <Link to="/members" style={{ color: "white", marginRight: 15 }}>Members</Link>
      <Link to="/transactions" style={{ color: "white" }}>Transactions</Link>
    </nav>
  );
}

export default Navbar;